import React, { Component } from 'react';
import { Modal, Spin, message, Tabs, Table, InputNumber, Button } from 'antd';
import API_URL from '../../../../common/url';
import $ from '../../../../common/AjaxRequest';

const TabPane = Tabs.TabPane;


class AdjustSiteFtePlan extends Component {
    state = {
        data: [],
        tabs: [], 
        record: {},
        loading: false,
        visible: false,
        canEdit: false,
        activeKey: 'site_before_start',
        beforeStartSiteFtes: [],
        visitSiteFtes: [],
        closeSiteFtes: [],
    }

    loadData = () => {
        const { record } = this.state;
        const { investigationSiteId } = record;
        this.setState({ loading: true })
        const options = {
            url: API_URL.plan.querySitePlanFteMonth,
            data: {
                investigationSiteId,
                afterTotal: false,
            },
            dataType: 'json',
            doneResult: res => {
                const { beforeStartSiteFtes, visitSiteFtes, closeSiteFtes } = res;
                let tabs = [];
                let activeKey = '';
                if (beforeStartSiteFtes) {
                    tabs.push({
                        title: '启动前计划FTE',
                        key: 'site_before_start',
                    });
                }
                if (visitSiteFtes) {
                    tabs.push({
                        title: '启动后-访视相关计划FTE',
                        key: 'site_visit',
                    });
                }
                if (closeSiteFtes) {
                    tabs.push({
                        title: '启动后-关中心计划FTE',
                        key: 'site_close',
                    });
                }
                activeKey = (tabs[0] || {}).key;
                (beforeStartSiteFtes || []).map(el => {
                    el.canEdit = false;
                });
                (visitSiteFtes || []).map(el => {
                    el.canEdit = false;
                });
                (closeSiteFtes || []).map(el => {
                    el.canEdit = false;
                });
                this.setState({
                    beforeStartSiteFtes,
                    visitSiteFtes,
                    closeSiteFtes,
                    loading: false,
                    activeKey,
                    tabs,
                });
            }, 
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    show = (record) => {
        this.setState({
            visible: true,
            record
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ 
            data: [],
            tabs: [], 
            record: {},
            loading: false,
            visible: false,
            canEdit: false,
            activeKey: 'site_before_start',
            beforeStartSiteFtes: [],
            visitSiteFtes: [],
            closeSiteFtes: [],
        });
    }

    handleChange = (value, index) => {
        const { activeKey, beforeStartSiteFtes, visitSiteFtes, closeSiteFtes } = this.state;
        if (activeKey === 'site_before_start') {
            beforeStartSiteFtes[index].value = value;
        } else if (activeKey === 'site_visit') {
            visitSiteFtes[index].value = value;
        } else {
            closeSiteFtes[index].value = value;
        }
        this.setState({ beforeStartSiteFtes, visitSiteFtes, closeSiteFtes });
    }

    // confirm = () => {
    //     const { beforeStartSiteFtes, afterStartSiteFtes, record: { investigationSiteId }  } = this.state;
    //     const { invId } = sessionStorage;
    //     let sendParams = {};
    //     (beforeStartSiteFtes || []).filter(row => row.detailId).map((el, index) => {
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].detailId`] = el.detailId;
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].fte`] = el.value;
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].year`] = el.year;
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].month`] = el.month;
    //     });
    //     (afterStartSiteFtes || []).filter(row => row.detailId).map((el, index) => {
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].detailId`] = el.detailId;
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].fte`] = el.value;
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].year`] = el.year;
    //         sendParams[`siteMonthPlanFteUpdateDtos[${index}].month`] = el.month;
    //     });
    //     this.setState({ loading: true });
    //     const options = {
    //         url: API_URL.plan.updateSiteMonthPlanFte,
    //         data: {
    //             ...sendParams,
    //             siteId: investigationSiteId,
    //             invId,
    //         },
    //         dataType: 'json',
    //         doneResult: (res) => {
    //             message.success(res.success);
    //             this.hide();
    //             this.setState({ loading: false }, () => {
    //                 this.props.loadData();
    //             });
    //         },
    //         errorResult: () => {
    //             this.setState({ loading: false });
    //         }
    //     };
    //     $.sendRequest(options);
    // }

    save = (record = {}) => {
        const { invId } = sessionStorage;
        const { activeKey } = this.state;
        this.setState({ loading: true });
        const options = {
            url: API_URL.plan.updateSiteMonthPlanFte,
            data: {
                'siteMonthPlanFteUpdateDtos[0].detailId': record.detailId,
                'siteMonthPlanFteUpdateDtos[0].fte': record.value,
                'siteMonthPlanFteUpdateDtos[0].year': record.year,
                'siteMonthPlanFteUpdateDtos[0].month': record.month,
                'siteMonthPlanFteUpdateDtos[0].fteType': activeKey,
                siteId: this.state.record.investigationSiteId,
                invId,
            },
            dataType: 'json',
            doneResult: (res) => {
                message.success(res.success);
                const { beforeStartSiteFtes = [], visitSiteFtes = [], closeSiteFtes = [] } = this.state;
                beforeStartSiteFtes.map(el => el.canEdit = false);
                visitSiteFtes.map(el => el.canEdit = false);
                closeSiteFtes.map(el => el.canEdit = false);
                this.setState({ 
                    loading: false, 
                    beforeStartSiteFtes, 
                    visitSiteFtes,
                    closeSiteFtes,
                }, () => {
                    this.props.loadData();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    getColumns = () => [{
        title: '时间',
        dataIndex: 'title',
        key: 'title',
        width: 120,
    }, {
        title: '计划FTE',
        dataIndex: 'value',
        key: 'value',
        width: 140,
        render: (text, record, index) => {
            const { canEdit } = record;
            return canEdit ? <InputNumber
                step={0.1}
                precision={2}
                min={0}
                placeholder="请输入"
                value={text}
                style={{ width: 120 }}
                onChange={value => this.handleChange(value, index)}
            /> : text
        }
    }, {
        title: '操作',
        dataIndex: 'operate',
        key: 'operate',
        width: 120,
        render: (text, record, index) => {
            const { updateFlag, canEdit } = record;
            return updateFlag ? <div>
                {
                    canEdit ?
                        <a onClick={() => this.save(record)}>保存</a>
                        :
                        <a onClick={() => this.changeCanEdit(index, true)}>修改</a>
                }
            </div> : '-'
        }
    }]

    changeCanEdit = (index, value) => {
        const { activeKey, beforeStartSiteFtes, visitSiteFtes, closeSiteFtes } = this.state;
        if (activeKey === 'site_before_start') {
            beforeStartSiteFtes[index].canEdit = value;
        } else if (activeKey === 'site_visit') {
            visitSiteFtes[index].canEdit = value;
        } else {
            closeSiteFtes[index].canEdit = value;
        }
        this.setState({ beforeStartSiteFtes, visitSiteFtes, closeSiteFtes });
    }

    handleTabsChange = (activeKey) => {
        this.setState({ activeKey });
    }

    render() {
        const { visible, loading, activeKey, record, tabs, beforeStartSiteFtes, visitSiteFtes, closeSiteFtes } = this.state;
        const { investigationSiteCode, investigationSiteName } = record;
        let dataSource = [];
        if (activeKey === 'site_before_start') {
            dataSource = beforeStartSiteFtes;
        } else if (activeKey === 'site_visit') {
            dataSource = visitSiteFtes;
        } else {
            dataSource = closeSiteFtes;
        }
        return (
            <Modal
                title='调整中心FTE计划'
                visible={visible}
                onCancel={this.hide}
                confirmLoading={loading}
                maskClosable={false}
                width="600px"
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                <Spin spinning={loading}>
                    <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20 }}>
                        <div>中心编号：{investigationSiteCode}</div>
                        <div style={{ marginLeft: 30 }}>中心名称：{investigationSiteName}</div>
                    </div>
                    <div>
                        <Tabs type='card' activeKey={activeKey} onChange={this.handleTabsChange}>
                            {tabs.map(el => <TabPane tab={el.title} key={el.key}></TabPane>)}
                        </Tabs>
                        <Table
                            columns={this.getColumns()}
                            dataSource={dataSource}
                            rowKey={record => record.title}
                            pagination={false}
                        />
                    </div>

                </Spin>
            </Modal>
        );
    }
}

export default AdjustSiteFtePlan;


// WEBPACK FOOTER //
// ./src/components/plan/siteFte/components/AdjustSiteFtePlan.js